module.exports = __webpack_public_path__ + "static/img/ys_1.a990920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/ys_1.png
// module id = 0vPu
// module chunks = 1